module.exports = __webpack_public_path__ + "assets/5fdd3c0ee54d750317b434446d4093da.jpg";